export default __webpack_public_path__ + "static/mascot_-35f46f7383e109f9a7c6faf01e6c0a35.svg";